import React from "react"
import { Provider } from "react-redux"
import { createStore as reduxCreateStore } from "redux"
import { rootReducer } from "."

const enchancer  = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : undefined

export const createStore = () => reduxCreateStore(rootReducer, enchancer )

export default ({ element }) => (
  <Provider store={createStore()}>
    {element}
  </Provider>
)
